import { getColors, getDarkMode } from '@/utils/Settings';

// app colour
export const appColour = () => {
    return "#810000";
}

// buttons
export const getButtonStyle = () => {

    const sx = {
        //border: 1,
        //color: "#FFFFFF",
        //backgroundColor: "#810000"
    };

    return sx;
}

// icon buttons
export const getIconButtonStyle = () => {

    const sx = {
        border:1,
        borderRadius: 1,
        //paddingX: 4,
        //paddingY: 0.8
        paddingX: 2,
        paddingY: 0.9
    };

    return sx;
}

// tabs
export const styleTabs = () => {

    const sxTabs = {
        "& .MuiTabs-indicator": {
            backgroundColor: "#810000",
            height: 3,
        },
        "& .MuiTab-root.Mui-selected": {
            color: '#810000'
        },
        "& .MuiTabs-flexContainer": {
            justifyContent: 'space-between'                
        },
        "& .MuiButtonBase-root.MuiTab-root": {
            minHeight: '60px'
        },
        "& .MuiSvgIcon-root.MuiTab-icon": {
            marginBottom: '0px'
        },
        zIndex:1,
        borderBottom: 1,
        borderColor: 'divider'
    };

    const sx = {
        minWidth: "fit-content", 
        maxWidth: '100%', 
        flex: 1 
    };

    const sxIcon = {
    
    }

    return { sxTabs, sx, sxIcon };
}

// for cards
export const styleCards = () => {
    
    const sxCardBox = {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(400px, 100%), 1fr))',
        gap: 2
    }

    const sxCardAction = {
        height: '100%',
        '&[data-active]': {
            backgroundColor: 'rgb(129,0,0,0.2)',
            '&:hover': {
                backgroundColor: 'action.selectedHover',
            },
        },
        '&:hover': {
            backgroundColor: 'rgb(129,0,0,0.1)',
        },
        cursor: 'pointer'
    };

    const sxCard = {        
        border: "1px solid rgb(129,0,0,0.4)",
        marginBottom: 1
    };

    // notifications
    const sxCardBoxNotifications = {
        width: '100%',
        maxWidth: '800px',
        marginX: 'auto'
    }

    const sxCardNotifications = {        
        border: "1px solid rgb(129,0,0,0.4)",
        marginBottom: 2
    };

    // departments
    const sxCardBoxDepartments = {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))',
        gap: 1
    }

    return { 
        sxCardBox, sxCard, 
        sxCardBoxNotifications, sxCardNotifications, 
        sxCardBoxDepartments, 
        sxCardAction
    };
}

// switch
export const getSliderStyle = () => {

    const darkmode = getDarkMode();
    const {lightColor,darkColor} = getColors();

    const sxSlider = {
        marginX:1,
        width:'99%',
        color: darkmode ? darkColor : lightColor,
        '& .MuiSlider-markLabel' : {
            fontSize: '12px',
            fontWeight: 'bold',
            marginTop: -0.5            
        }
    };

    return { sxSlider };
}

// breadcrumbs
export const getBreadcrumbsStyle = () => {

    const sxBreadcrumbsResources = {
        display: 'flex',
        alignItems: 'center',
        color: '#810000',
        fontSize: 20,
        cursor: 'pointer'
    };

    return { sxBreadcrumbsResources };
}

// backdrops
export const styleBackdrop = () => {

    const sxBackdrop = {
        zIndex: (theme) => theme.zIndex.drawer + 1, // Opcional: asegura que esté encima de todo
        display: 'flex',
        alignItems: 'center', // Centrado vertical
        justifyContent: 'center', // Centrado horizontal
    };

    return { sxBackdrop };
}

// box
export const getBoxStyle = () => {

    const sxBoxSticky = {
        position:'sticky',
        top: 0,
        zIndex: 1000,
        bgcolor: 'background.paper'
    };

    return { sxBoxSticky };
}